import { render, staticRenderFns } from "./otaList.vue?vue&type=template&id=3025c5f2&scoped=true"
import script from "./otaList.vue?vue&type=script&lang=js"
export * from "./otaList.vue?vue&type=script&lang=js"
import style0 from "./otaList.vue?vue&type=style&index=0&id=3025c5f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3025c5f2",
  null
  
)

export default component.exports